module.exports = __webpack_public_path__ + "static/media/sistemaPegar10.d5909231.jpg";